const PIXEL_ID = '1545009850674181'

let initialized = false

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: unknown
  }
}

export function initPixel() {
  if (initialized || typeof window === 'undefined') return

  try {
    /* Official Meta Pixel base code */
    ;(function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return
      const n: any = (f.fbq = function (...args: unknown[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
      })
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      const t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = v
      const s = b.getElementsByTagName(e)[0]
      s.parentNode?.insertBefore(t, s)
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )

    window.fbq?.('init', PIXEL_ID)
    window.fbq?.('track', 'PageView')
    initialized = true
  } catch (err) {
    /* Never let analytics break the page */
    console.warn('Meta Pixel init failed:', err)
  }
}

export function trackEvent(event: string, data?: Record<string, unknown>) {
  if (typeof window === 'undefined' || !window.fbq) return
  try {
    window.fbq('track', event, data)
  } catch (err) {
    console.warn('Meta Pixel track failed:', err)
  }
}
